module.exports = __webpack_public_path__ + "img/tab2s.48b989ad.jpg";